import React from 'react';
import { graphql } from 'gatsby';
import get from 'lodash/get';
import {
  Text
} from '@comicrelief/component-library';

import Layout from '../../components/Layout/Layout';
import { SEO, SEO_PAGE_TYPES } from '../../components/SEO/SEO';
import renderBody from '../../components/RichText/RichText';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import { Wrapper, Container, Header } from './Default.styles';

class Default extends React.Component {
  render() {
    const page = get(this.props, 'data.allContentfulPageDefault.edges[0].node');

    const {
      title, body, parentPages, showBreadcrumb
    } = page;

    return (
      <Layout>
        <Wrapper>

          { showBreadcrumb
            && (
            <Breadcrumb
              thisPageTitle={title}
              parentPages={parentPages}
            />
            )}

          <Header>
            <Text tag="h1">
              {title}
            </Text>
          </Header>
          <Container>{body ? renderBody(body, 'white', 'defaultPage') : null}</Container>
        </Wrapper>
      </Layout>
    );
  }
}

export default Default;

export const Head = props => (
  <SEO
    allData={props}
    pageType={SEO_PAGE_TYPES.DEFAULT}
    listAsArticle
  />
);

export const pageQuery = graphql`
  query getDefault($slug: String) {
    allContentfulPageDefault(filter: { path: { eq: $slug } }) {
      edges {
        node {
          title
          path
          body {
            raw
            references {
              ...Accordion
              ...Asset
              ...HtmlCode
            }
          }
          showBreadcrumb
          parentPages {
            ... on Node {
              ... on ContentfulPageLandingPage {
                title
                path
              }
                ... on ContentfulPageDefault {
                title
                path
              }
            }
          }
        }
      }
    }
  }
`;
